import { FormikProvider, useFormik } from 'formik';
import { LINKED_IN_URL_REGEX, TWITTER_REGEX, URL_REGEX } from 'lib/regex';
import FormProfilePicture from 'src/screens/company/components/CompleteProfile/FormProfilePicture';
import { Button } from 'src/shared-components';
import { InputField, TextArea } from 'src/shared-components/Form';
import * as Yup from 'yup';

const DEFAULT_USER_AVATAR = process.env.DEFAULT_USER_AVATAR || '';

const CustomerUserComplete = ({
  onFormSubmitted,
  buttonText = 'Next',
}: {
  onFormSubmitted: (values: any) => void;
  buttonText?: string;
}) => {
  const form = useFormik({
    initialValues: {
      bio: '',
      twitterUsername: '',
      linkedInLink: '',
      photoUrl: '',
    },
    validationSchema: Yup.object().shape({
      bio: Yup.string()
        .required('A bio is required')
        .min(20, 'Minimum number of characters is 20')
        .max(160, 'Maximum number of characters is 160'),
      socialLinks: Yup.object().shape({
        link: Yup.object().shape({
          website: Yup.string().matches(URL_REGEX, 'Website should be a valid URL'),
          twitterUsername: Yup.string().matches(TWITTER_REGEX, 'Hey please only input your username without the @'),
          linkedInLink: Yup.string().matches(LINKED_IN_URL_REGEX, 'Hey is this a valid LinkedIn URL?'),
        }),
        photoUrl: Yup.string(),
      }),
    }),
    onSubmit: values => {
      onFormSubmitted(values);
    },
  });

  const { isValid, handleSubmit, setFieldValue, values } = form;

  return (
    <FormikProvider value={form}>
      <div className="flex flex-col gap-y-4 p-3">
        <div className="mb-6">
          <FormProfilePicture
            photoUrl={values.photoUrl || DEFAULT_USER_AVATAR}
            onFileUploaded={url => setFieldValue('photoUrl', url)}
            onRemovePhotoUrl={() => setFieldValue('photoUrl', null)}
            photoRoundness="md"
            flexStyle
          />
        </div>
        <TextArea
          name="bio"
          autoComplete="off"
          label="1-2 sentence bio"
          placeholder="1-2 sentences about you, your mission, passions, previous wins, etc."
          rows={3}
          required
        />
        <InputField
          name="twitterUsername"
          autoComplete="off"
          label="Twitter username"
          placeholder="Twitter username without @"
        />
        <InputField
          name="linkedInLink"
          autoComplete="off"
          label="linkedin profile link"
          placeholder="www.linkedin.com/username"
        />
        <Button
          onClick={() => handleSubmit()}
          size="xl"
          className="bg-[#151515]"
          roundness="md"
          color="black"
          fullWidth
          disabled={!isValid}
        >
          {buttonText}
        </Button>
      </div>
    </FormikProvider>
  );
};

export default CustomerUserComplete;
